module.exports = __webpack_public_path__ + "img/quality-monitoring.0f024ab.png";